import React from 'react';
import styles from './SaveButton.module.css';


const SaveButton = ({ handleSave }) => {
    return (
        <div className={styles.buttonContainer}>
            <button onClick={handleSave} className={styles.saveButton}>Save</button>
        </div>

    );
};

export default SaveButton;